import React from 'react';
import { Shield, LogOut, AlertTriangle } from 'lucide-react';
import { adminImpersonationService } from '../utils/adminImpersonationService';

/**
 * AdminImpersonationBanner Component
 * Shows a prominent banner when admin is viewing another user's account
 */
const AdminImpersonationBanner = ({ currentUser, onExitImpersonation }) => {
  const impersonationState = adminImpersonationService.getImpersonationState();

  if (!impersonationState) return null;

  return (
    <div className="sticky top-0 bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left side - Warning info */}
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <AlertTriangle className="w-5 h-5" />
              <Shield className="w-5 h-5" />
            </div>
            <div>
              <p className="font-semibold text-sm">
                ADMIN MODE: Viewing as {currentUser?.first_name} {currentUser?.last_name}
              </p>
              <p className="text-xs opacity-90">
                {currentUser?.email} •
                {currentUser?.user_type === 'provider' ? ' Healthcare Provider' : ' Sales Representative'}
                {currentUser?.company && ` • ${currentUser.company}`}
              </p>
            </div>
          </div>

          {/* Right side - Exit button */}
          <button
            onClick={onExitImpersonation}
            className="flex items-center space-x-2 px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors backdrop-blur-sm"
          >
            <LogOut className="w-4 h-4" />
            <span className="font-medium text-sm">Exit & Return to Admin</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminImpersonationBanner;
